import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetch } from "../../Util/axios_helper";

const initialState = {
  countsReportData: [],
  countsReportDataLoaded: false,
  userFilterData: [],
  userFilterDataLoaded: false,
  url: "",
  UrlCS: "",
  UrlSms: "",
  UrlForCallLog: "",
  CS: 0,
  Sms: 0,
  callLog: 0,
  refresh: 0,
  matrixBallroom: "",
};

export const getCountsOnLeadReportData = createAsyncThunk(
  "getCountsOnLeadReportData",
  async (obj) => {
    obj.years =
      obj.years === "" ? new Date().getFullYear().toString() : obj.years;
    return await fetch(
      `Report/CountsOnLead_Report?type=${obj.type}&years=${obj.years}&filter=${obj.filter}&metrics=${obj.metrics}&value=${obj.value}`
    );
  }
);

export const getUserFilterReportData = createAsyncThunk(
  "getUserFilterReportData",
  async (obj) => {
    return await fetch(`Report/GetUserReportFilter?UserId=${obj.UserId}`);
  }
);

const ReportSlice = createSlice({
  name: "reportData",
  initialState,
  reducers: {
    UrlForCOL: (state, action) => {
      state.url = action.payload;
      state.refresh = state.refresh + 1;
      state.CS = 0;
      state.Sms = 0;
      state.callLog = 0;
    },
    UrlForCS: (state, action) => {
      state.UrlCS = action.payload;
      state.CS = state.CS + 1;
      state.refresh = 0;
      state.Sms = 0;
      state.callLog = 0;
    },
    UrlForSMS: (state, action) => {
      state.UrlSms = action.payload;
      state.Sms = state.Sms + 1;
      state.CS = 0;
      state.refresh = 0;
      state.callLog = 0;
    },
    UrlForCallLog: (state, action) => {
      state.UrlForCallLog = action.payload;
      state.callLog = state.callLog + 1;
      state.Sms = 0;
      state.CS = 0;
      state.refresh = 0;
    },
    Reset: (state) => {
      state.callLog = 0;
      state.Sms = 0;
      state.CS = 0;
      state.refresh = 0;
    },
    Onballroommatrixchange: (state, data) => {
      state.matrixBallroom = data.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCountsOnLeadReportData.pending, (state) => {
      state.countsReportDataLoaded = false;
    });
    builder.addCase(getCountsOnLeadReportData.fulfilled, (state, action) => {
      state.countsReportData = action.payload;
      state.countsReportDataLoaded = true;
    });
    builder.addCase(getCountsOnLeadReportData.rejected, (state) => {
      state.countsReportData = null;
      state.countsReportDataLoaded = true;
    });
    builder.addCase(getUserFilterReportData.pending, (state) => {
      state.userFilterDataLoaded = false;
    });
    builder.addCase(getUserFilterReportData.fulfilled, (state, action) => {
      state.userFilterData = action.payload;
      state.userFilterDataLoaded = true;
    });
    builder.addCase(getUserFilterReportData.rejected, (state) => {
      state.userFilterData = null;
      state.userFilterDataLoaded = true;
    });
  },
});

export const { UrlForCOL } = ReportSlice.actions;
export const { UrlForCS } = ReportSlice.actions;
export const { UrlForSMS } = ReportSlice.actions;
export const { UrlForCallLog } = ReportSlice.actions;
export const { Reset, Onballroommatrixchange } = ReportSlice.actions;

export default ReportSlice.reducer;
